import React from 'react';
import { ConfirmationModal } from '@shootsta/common-react';

function getSubtitle(text: string) {
  return <span>{text}</span>;
}

export default function ImportFailedModal({
  visible,
  onClose,
  onConfirmation
}: {
  visible?: boolean;
  onConfirmation?: any;
  onClose?: any;
}) {
  return (
    <ConfirmationModal
      visible={visible}
      onClose={onClose}
      onSave={onConfirmation}
      subtitle={getSubtitle('Retry the import?')}
      title="Import Failed!"
      saveBtnText="RETRY"
    />
  );
}
